import React from "react";

// base funcional atual (legado controlado)
import Doses from "./Doses";

/**
 * 📌 Page oficial da v4 para o domínio Routine
 *
 * Responsabilidade:
 * - representar o domínio de rotina na navegação oficial
 * - desacoplar a rota nova da implementação antiga baseada em Doses
 *
 * Estratégia atual:
 * - reutiliza a base funcional existente (Doses)
 * - permite evolução futura sem quebrar a navegação
 */
export default function Routine() {
  return <Doses />;
}